export default __webpack_public_path__ + "static/media/gold-chest-close-tab.7e1d090f.png";